var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-input',{attrs:{"placeholder":"请输入法号"},on:{"input":_vm.sendBuddhistName},model:{value:(_vm.buddhistName),callback:function ($$v) {_vm.buddhistName=$$v},expression:"buddhistName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }